module.exports = __webpack_public_path__ + "img/1557614087415865347.bef54d78.png";